import PocketBase from 'pocketbase';

const pb = new PocketBase('https://patisseriemillet.infocolab.online');

export default pb;
